// Gallery category filtering.

// Pure: does an item in `category` show under the active `filter`?
export function matchesFilter(category, filter) {
  return filter === "all" || category === filter
}

export function initGallery(doc = document) {
  const gallery = doc.querySelector(".gallery")
  if (!gallery) return

  const buttons = gallery.querySelectorAll("menu button")
  const items = gallery.querySelectorAll(".gallery-grid > li")
  const expandBtn = gallery.querySelector("#gallery-see-more")

  if (expandBtn) {
    expandBtn.addEventListener("click", () => {
      gallery.classList.remove("collapsed")
    })
  }

  buttons.forEach((btn) => {
    btn.addEventListener("click", () => {
      const filter = btn.dataset.filter

      // Auto-expand if the user interacts with the filters
      gallery.classList.remove("collapsed")

      buttons.forEach((b) => b.setAttribute("aria-pressed", String(b === btn)))
      items.forEach((item) => {
        item.hidden = !matchesFilter(item.dataset.category, filter)
      })
    })
  })
}
